import React from 'react';

const Plus = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" viewBox="0 0 34 34">
      <circle cx="17" cy="17" r="16.5" stroke="#000" />
      <path d="M16.2 22.45c0 .18.12.3.3.3h.96c.18 0 .3-.12.3-.3v-4.8c0-.12.06-.18.18-.18h4.74c.18 0 .3-.12.3-.3v-.9c0-.18-.12-.3-.3-.3h-4.74c-.12 0-.18-.06-.18-.18v-4.8c0-.18-.12-.3-.3-.3h-.96c-.18 0-.3.12-.3.3v4.8c0 .12-.06.18-.18.18h-4.74c-.18 0-.3.12-.3.3v.9c0 .18.12.3.3.3h4.74c.12 0 .18.06.18.18v4.8z" />
    </svg>
  );
};

export default React.memo(Plus);
